module.exports = __webpack_public_path__ + "img/1.ac4b312d.jpg";